import CompactShopTheLook from '../../../../shop-the-look-compact/components/CompactShopTheLook'
import { getBuilderBlockMount } from '../../../utils/getBuilderBlockMount'

interface Props {
  className?: string
}

export const BuilderCompactShopTheLook = ({ className }: Props) => {
  const mount = getBuilderBlockMount('builder-compact-shop-the-look')
  if (!mount) return null

  return (
    <div className={className}>
      <CompactShopTheLook mount={mount} />
    </div>
  )
}
